export function reportFieldValue(
  fieldName: string,
  value: string,
  onValueChange?: (fieldName: string, value: string) => void,
) {
  onValueChange?.(fieldName, value);
}
